import { PipelineCard } from '../_components';

export function EngineeredStandards() {
  return (
    <>
      <h2 className="text-[var(--gold)] text-[18px] font-semibold mb-3 mt-8">
        Engineered to institutional standards
      </h2>
      <p className="text-[13px] text-[#cbd5e1] leading-relaxed max-w-4xl mb-4">
        The signal is only as good as the data behind it and the engineering that
        keeps that data trustworthy. Triumph runs the entire pipeline on hardware
        we own and maintain, against data sources we pay for directly, with
        checks that surface any drift the moment it happens.
      </p>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-4">
        <PipelineCard title="Where the data comes from">
          Every fundamental and forward consensus field used in the score is
          sourced through a Bloomberg API service running on a Triumph operated
          host, with user mode authentication that allows the same field coverage
          as the terminal itself. A second commercial data feed serves as a
          fallback and a cross check on price history. Every fetch is logged,
          time stamped, and counted; the morning refresh writes a versioned
          snapshot of the entire scored universe to a permanent archive.
        </PipelineCard>
        <PipelineCard title="The morning chain">
          A scheduled job runs every weekday before six. It refreshes
          fundamentals, refreshes forward consensus estimates, recomputes the
          scored universe, recomputes the Alpha Zone, repaints the daily
          snapshot archive, regenerates the morning research note, refreshes
          option chains for every holding, repaints the public website, and
          runs cross file integrity checks. By the time the manager sits down
          at the desk, the workbench is current.
        </PipelineCard>
        <PipelineCard title="How errors are caught">
          Three layers protect the data. A daily integrity check verifies that
          scores, the live basket, the price cache, and the portfolio book are
          mutually consistent on every refresh; if any check fails, a red banner
          appears site wide. A weekly automated code health audit checks build
          state, security advisories, and architectural drift. A pipeline page
          shows a rolling five day status grid for every external pull and gives
          one click recovery for any failed cell.
        </PipelineCard>
      </div>
      <p className="text-[13px] text-[#cbd5e1] leading-relaxed max-w-4xl mb-6">
        The result is a workbench that does for the Triumph portfolio manager
        what the desks of the largest institutional shops do for theirs, run by
        a focused team that can actually act on what it sees. The signal is
        real: twelve annual vintages, over six thousand stock-years of forward
        returns, survivorship-corrected Sharpe of 1.31 at 15.7% vol, and an
        average annual edge of 7.7
        percentage points against the rest of the universe. The engineering is
        real: zero type errors, zero lint warnings, full test coverage of the
        scoring code, automated daily integrity checks, automated weekly code
        health audits. The transparency is real: the model itself, the code,
        the live basket, the backtest, and the audit script are all visible
        inside the application that produced this report.
      </p>
    </>
  );
}
